











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import get from 'lodash.get';
import snakecase from 'lodash.snakecase';
import { IFile } from '@resclick/data-access';
import { i18n } from '@/i18n';

@Component
export default class RoomInfoModal extends Vue {
  @Prop() value!: boolean;
  @Prop() room!: any;
  currentSlide = 1;

  get slides() {
    return this.room?.images || [];
  }

  get features() {
    const map = [
      {
        key: 'layout',
        label: i18n.t('AMENITIES.ROOM_LAYOUT'),
        children: [
          {
            key: 'roomSize',
            label: (layout: any) => {
              return `${layout.roomSize} ${i18n.t('AMENITIES.' + layout.roomSizeUnit)}`;
            },
          },
          { key: 'separateDiningArea' },
          { key: 'separateSittingArea' },
          { key: 'sharedAccommodations' },
          { key: 'desk' },
          { key: 'laptopFriendlyWorkspace' },
          { key: 'fireplace' },
          { key: 'heatedFloors' },
          { key: 'accessViaExteriorCorridors' },
          { key: 'privatePool' },
          { key: 'privatePlungePool' },
          { key: 'privateSpaTub' },
          {
            key: 'outdoorSpaces',
            label: (layout: any) => {
              return `${i18n.t('AMENITIES.OUTDOOR_SPACES')}: ${i18n.t('AMENITIES.' + layout.outdoorSpaces)}`;
            },
          },
          { key: 'individuallyDecorated' },
          { key: 'individuallyFurnished' },
          {
            key: 'connectingRoomsAvailable',
            label: i18n.t('AMENITIES.CONNECTING_ADJOINING_ROOMS_AVAILABLE'),
          },
          { key: 'yard' },
          { key: 'noWindows' },
          { key: 'inRoomPlaypen' },
        ],
      },
      {
        key: 'bathroom',
        children: [
          {
            key: 'primaryBathroom',
            label: (bathroom: any) => {
              return `${i18n.t('AMENITIES.PRIMARY_BATHROOM')}: ${i18n.t('AMENITIES.' + bathroom.primaryBathroom)}`;
            },
          },
          {
            key: 'numberOfBathrooms',
            label: (bathroom: any) => {
              return `${i18n.t('AMENITIES.NUMBER_OF_BATHROOMS')}: ${bathroom.numberOfBathrooms}`;
            },
          },
          { key: 'bathrobes' },
          {
            key: 'childrenBathrobes',
            label: i18n.t('AMENITIES.CHILD_SIZE_BATHROBES'),
          },
          { key: 'heatedFloor' },
          { key: 'freeToiletries' },
          { key: 'designerToiletries' },
          { key: 'soap' },
          { key: 'shampoo' },
          { key: 'toiletPaper' },
          { key: 'hairDryer' },
          { key: 'bidet' },
          {
            key: 'bathType',
            label: (bathroom: any) => {
              return `${i18n.t('AMENITIES.BATH_TYPE')}: ${i18n.t('AMENITIES.' + bathroom.bathType)}`;
            },
          },
          {
            key: 'bathtubType',
            label: (bathroom: any) => {
              return `${i18n.t('AMENITIES.BATHTUB_TYPE')}: ${i18n.t('AMENITIES.' + bathroom.bathtubType)}`;
            },
          },
          { key: 'hydroMassageShowerhead' },
          { key: 'rainfallShowerhead' },
        ],
      },
      {
        key: 'bedding',
        children: [
          {
            key: 'hypoAllergenicBedding',
            label: i18n.t('AMENITIES.HYPO_ALLERGENIC_BEDDING_AVAILABLE'),
          },
          {
            key: 'premiumBedding',
            label: i18n.t('AMENITIES.PREMIUM_BEDDING_AVAILABLE'),
          },
          {
            key: 'premiumLinenType',
            label: (bedding: any) => {
              return `${i18n.t('AMENITIES.PREMIUM_LINENS')}: ${i18n.t('AMENITIES.' + bedding.premiumLinenType)}`;
            },
          },
          {
            key: 'premiumMattressType',
            label: (bedding: any) => {
              let key = '';

              switch (bedding.premiumMattressType) {
                case 'MEMORY_FOAM': {
                  key = 'MEMORY_FOAM_MATTRESS';
                  break;
                }
                case 'PILLOW_TOP': {
                  key = 'PILLOW_TOP_MATTRESS';
                  break;
                }
                case 'TEMPUR_PEDIC': {
                  key = 'TEMPUR_PEDIC_MATTRESS';
                  break;
                }
              }

              return `${i18n.t('AMENITIES.PREMIUM_MATTRESS_TYPE')}: ${i18n.t('AMENITIES.' + key)}`;
            },
          },
          { key: 'pillowMenu' },
          { key: 'downComforter' },
        ],
      },
      {
        key: 'accessibility',
        children: [
          { key: 'accessibleBathroom' },
          { key: 'rollInShower' },
          { key: 'inRoomAccessibility' },
          { key: 'availableInGuestrooms' },
          { key: 'transferShower' },
          { key: 'accessibleBathtub' },
          { key: 'portableBathtubSeat' },
          { key: 'bathroomGrabBars' },
          { key: 'raisedToiletSeat' },
          { key: 'visualFireAlarm' },
          { key: 'doorbellTelephoneNotification' },
          { key: 'vibratingPillowAlarm' },
          { key: 'leverDoorHandles' },
          { key: 'wheelchairWidthDoorways' },
          { key: 'heightAdjustedAmenities' },
          { key: 'telephoneAccessibilityKit' },
        ],
      },
      {
        key: 'kitchen',
        children: [
          {
            key: 'available',
            label: (kitchen: any) => {
              return i18n.t('AMENITIES.' + kitchen.type) as string;
            },
          },
          { key: 'cookwareDishwareUtensils' },
          { key: 'dishwasher' },
          {
            key: 'refrigerator',
            label: (kitchen: any) => {
              return i18n.t('AMENITIES.' + kitchen.refrigeratorType) as string;
            },
          },
          { key: 'oven' },
          {
            key: 'microwave',
            label: (kitchen: any) => {
              return i18n.t('AMENITIES.' + kitchen.microwaveType) as string;
            },
          },
          { key: 'riceCooker' },
          { key: 'stovetop' },
          {
            key: 'minibar',
            label: (kitchen: any) => {
              return i18n.t('AMENITIES.' + kitchen.minibarType) as string;
            },
          },
        ],
      },
      {
        key: 'inRoomRefreshment',
        children: [
          { key: 'freeBottledWater' },
          { key: 'coffeeTeaMaker' },
          { key: 'espressoMaker' },
          { key: 'electricKettle' },
        ],
      },
      {
        key: 'inRoomEntertainment',
        children: [
          {
            key: 'television',
            label: (inRoomEntertainment: any) => {
              return i18n.t('AMENITIES.' + inRoomEntertainment.televisionType) as string;
            },
          },
          { key: 'dvdPlayer' },
          {
            key: 'iPodDocStation',
            label: i18n.t('AMENITIES.IPOD_DOC_STATION'),
          },
          { key: 'mp3DocStation', label: i18n.t('AMENITIES.MP3_DOC_STATION') },
          { key: 'videoGameConsole' },
          {
            key: 'computerOrTablet',
            label: (inRoomEntertainment: any) => {
              return i18n.t('AMENITIES.' + inRoomEntertainment.computerType) as string;
            },
          },
          {
            key: 'channels',
            label: (inRoomEntertainment: any) => {
              return inRoomEntertainment.channels.map((channel: string) => i18n.t('AMENITIES.' + channel)).join(', ');
            },
          },
        ],
      },
      {
        key: 'climateControl',
        children: [
          {
            key: 'airConditioning',
            label: (climateControl: any) => {
              return `${i18n.t('AMENITIES.AIR_CONDITIONING_TYPE')}: ${i18n.t(
                'AMENITIES.' + climateControl.airConditioningType,
              )}`;
            },
          },
          { key: 'fan' },
          { key: 'ceilingFan' },
          { key: 'portableFan' },
          {
            key: 'heating',
            label: (climateControl: any) => {
              return `${i18n.t('AMENITIES.HEATING_TYPE')}: ${i18n.t('AMENITIES.' + climateControl.heatingType)}`;
            },
          },
        ],
      },
    ];

    const categories = map
      .filter((category) => {
        return this.amenities[category.key];
      })
      .map((category) => {
        const currentCategory = this.amenities[category.key];
        return {
          key: category.key,
          label: category.label || i18n.t('AMENITIES.' + this.toPascalCase(category.key)),
          children: category.children
            .filter((amenity) => {
              if (
                amenity.key === 'bathtubType' &&
                !['SHOWER_TUB_COMBINATION', 'BATHTUB', 'SEPARATE_BATHTUB_AND_SHOWER', 'BATHTUB_OR_SHOWER'].includes(
                  currentCategory['bathType'],
                )
              ) {
                return false;
              }

              if (amenity.key === 'premiumLinenType' && !currentCategory['premiumBedding']) {
                return false;
              }

              return currentCategory[amenity.key];
            })
            .map((amenity: any) => {
              const amenityLabel =
                typeof amenity.label === 'function'
                  ? amenity.label(currentCategory)
                  : amenity.label || i18n.t('AMENITIES.' + this.toPascalCase(amenity.key));

              return {
                key: amenity.key,
                label: amenityLabel,
              };
            }),
        };
      })
      .filter((category) => category.children && category.children.length);

    return categories;
  }

  get amenities() {
    return this.room.amenities || {};
  }

  get(key: string) {
    return get(this.amenities, key);
  }

  toPascalCase(string: string) {
    return snakecase(string).toUpperCase();
  }

  imagePath(image: IFile, size: keyof IFile['sizes']) {
    if (image?.sizes?.[size]) {
      return process.env.VUE_APP_CDN_URL + '/' + image.sizes[size];
    } else return '';
  }

  @Watch('value')
  onOpen() {
    this.currentSlide = 1;
  }
}
